<template>
  <v-row justify="center" style="width:100%">    
      <v-card>
        <v-card-title>
          <h2>Prozesssteckbrief</h2>
          <v-chip
            class="ma-2"
            color="primary"
          >
            Ausgefüllt {{ countNonEmptyProperties(processCharacteristic, '') }} von {{ countNullAndEmptyProperties(processCharacteristic, '') }}
          </v-chip>
          <v-spacer />
          <v-btn
            v-if="!viewMode"
            color="primary"
            @click="addField"
          >
            Feld hinzufügen
          </v-btn>
          <!-- <v-btn icon @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn> -->
        </v-card-title>
        <v-card-text class="pb-7">
            <v-form v-model="valid">
            <v-container>
              <v-row id="rowContainer">
                <v-col cols="4">
                  Name des Prozesses
                </v-col>
                <v-col cols="8">
                  <v-text-field
                  label="Name des Prozesses"
                  v-model="processCharacteristic.name"
                  :disabled="viewMode"
                ></v-text-field>
                </v-col>
              </v-row>
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    Allgemeines
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row id="rowContainer">
                      <v-textarea
                        name="trigger"
                        label="Was ist der Prozessauslöser?"
                        required
                        v-model="processCharacteristic.trigger"
                        :disabled="viewMode"
                      ></v-textarea>
                    </v-row>
                    <v-row id="rowContainer">
                      <v-textarea
                        name="outcome"
                        label="Was ist das Ergebnis des Prozesses?"
                        required
                        v-model="processCharacteristic.outcome"
                        :disabled="viewMode"
                      ></v-textarea>
                    </v-row>
                    <v-row id="rowContainer">
                      <v-textarea
                        name="description"
                        label="Was sind die wichtigsten Schritte im Prozessablauf?"
                        required
                        v-model="processCharacteristic.description"
                        :disabled="viewMode"
                      ></v-textarea>
                    </v-row>
                    
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header>
                    Schnittstellen/Beteiligte
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row id="rowContainer">
                      <v-col cols="4">
                        Beteiligte Rollen
                      </v-col>
                      <v-col :cols="canEditProcessobjects ? '7':'8'">
                        <v-select
                          v-model="processCharacteristic.involvedRoles"
                          :items="roles"
                          item-text="name"
                          item-value="id"
                          attach
                          chips
                          label="Beteiligte Rollen"
                          multiple
                          :disabled="viewMode"
                        ></v-select>
                      </v-col>
                      <v-col cols="1" v-if="canEditProcessobjects">
                        <v-btn fab small color="primary" elevation="0">
                          <v-icon @click="openDialog('ROLE')">add</v-icon >
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row id="rowContainer">
                      <v-col cols="4">
                        Abteilung
                      </v-col>
                      <v-col :cols="canEditProcessobjects ? '7':'8'">
                        <v-select
                          :items="departments"
                          item-text="name"
                          item-value="id"
                          label="Abteilung"
                          v-model="processCharacteristic.department"
                          :disabled="viewMode"
                        ></v-select>
                      </v-col>
                      <v-col cols="1" v-if="canEditProcessobjects">
                        <v-btn fab small color="primary" elevation="0">
                          <v-icon @click="openDialog('DEPARTMENT')">add</v-icon >
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row id="rowContainer">
                      <v-col cols="4">
                        Schnittstellen zu anderen Abteilungen
                      </v-col>
                      <v-col cols="8">
                        <v-select
                          v-model="processCharacteristic.connectedDepartments"
                          :items="departments"
                          item-text="name"
                          item-value="id"
                          attach
                          chips
                          label="Schnittstellen zu anderen Abteilungen"
                          multiple
                          :disabled="viewMode"
                          :menu-props="{
                            maxHeight: '200px', // Adjust the max height as needed
                          }"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row id="rowContainer">
                      <v-col cols="4">
                        IT-Systeme
                      </v-col>
                      <v-col :cols="canEditProcessobjects ? '7':'8'">
                        <v-select
                          :disabled="viewMode"
                          v-model="processCharacteristic.systems"
                          :items="systems"
                          item-text="name"
                          item-value="id"
                          attach
                          chips
                          label="IT-Systeme"
                          multiple
                        ></v-select>
                      </v-col>
                      <v-col cols="1" v-if="canEditProcessobjects">
                        <v-btn fab small color="primary" elevation="0">
                          <v-icon @click="openDialog('SYSTEM')">add</v-icon >
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header>
                    Sonstiges
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row id="rowContainer">
                      <v-radio-group
                        v-model="processCharacteristic.connectedModel"
                        row
                        :disabled="viewMode"
                      >
                      <template v-slot:label>
                        <div>BPMN-Modell verknüpfen</div>
                      </template>
                        <v-radio
                          label="Ja"
                          :value="true"
                        ></v-radio>
                        <v-radio
                          label="Nein"
                          :value="false"
                        ></v-radio>
                      </v-radio-group>
                    </v-row>
                    <div v-for="field in customFields" :key="field.key">
                      <v-row v-if="field.fieldType == 'SELECT'" id="rowContainer">
                        <v-col cols="4">
                          {{field.name}}
                        </v-col>
                        <v-col cols="8">
                          <v-select
                            v-model="customFieldValues[field.fieldId].value"
                            :items="field.options"
                            :label="field.name"
                            :disabled="viewMode"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row v-if="field.fieldType == 'NUMBER'" id="rowContainer">
                        <v-col cols="4">
                          {{field.name}}
                        </v-col>
                        <v-col cols="8">
                          <v-text-field
                            :label="field.name"
                            v-model="customFieldValues[field.fieldId].value"
                            type="number"
                            :disabled="viewMode"
                            :rules="minMaxRules"
                        ></v-text-field>
                        </v-col>
                      </v-row>
                    </div>
                    
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="pr-6 pb-6">
          <v-btn text @click.stop="close" id="leftButton">Abbrechen</v-btn>
          <v-btn elevation="0" v-if="!viewMode"
                  color="primary"
                  @click="sendResponse" id="rightButton">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    <ConnectedRessourceDialog ref="ressourceDialog"/>
    <AddCustomFieldDialog ref="customFieldDialog" />
  </v-row>
</template>

<script>
import ConnectedRessourceDialog from '@/pages/ProcessModeling/CustomModelingTools/ConnectedRessources/ConnectedRessourceDialog.vue';
import connectedRessourceService from '@/pages/ProcessModeling/CustomModelingTools/ConnectedRessources/connectedRessourceService.js'
import AddCustomFieldDialog from './AddCustomFieldDialog.vue';
import processMapService from '@/components/processMapService.js';
export default {
  name: "NewProcessCharacteristicsDialog",
  components:{
    ConnectedRessourceDialog,
    AddCustomFieldDialog
  },
  data() {
    return {
      minMaxRules: [
        v => !!v || "Dieses Feld muss ausgefüllt werden",
      ],
      dialog: false,
      roles: [],
      systems: [],
      departments:[],
      resolve: null,
      reject: null,
      message: null,
      title: null,
      viewMode: false,
      options: {
        width: 800,
        zIndex: 400,
      },
      processType: [
        {name: "Kernprozess", value: "CORE"},
        {name: "Führungsprozess", value:"LEADERSHIP"},
        {name: "Unterstützungsprozess", value:"SUPPORT"}
      ],
      highMidLowOptions: [
        {name: "Hoch", value: "HIGH"},
        {name: "Mittel", value: "MEDIUM"},
        {name: "Gering", value: "LOW"}
      ],
      processCharacteristic: {
        name: null,
        trigger: null,
        outcome: null,
        description: null,
        department: null,
        systems: null,
        connectedDepartments: [],
        connectedModel: null,
        involvedRoles: null,
        connectedProcesses: [],
        customFields: []

      },
      customFieldValues:{},
      characteristics: null,
      customFields: [],
      canEditProcessobjects: false
    };
  },
  computed:{
    countNonEmptyProperties(obj, excludedPropertyName) {
      let count = 0;

      for (const key in obj) {
        if (obj.hasOwnProperty(key) && key !== excludedPropertyName && obj[key] !== null && obj[key] !== undefined) {
          if (Array.isArray(obj[key])) {
            if (obj[key].length > 0) {
              count++;
            }
          } else {
            count++;
          }
        }
      }

      return count;
    },
    countNullAndEmptyProperties(obj, excludedPropertyName) {
      let count = 0;

      for (const key in obj) {
        if (obj.hasOwnProperty(key) && key !== excludedPropertyName) {
          const value = obj[key];

          if (value === null) {
            count++;
          } else if (Array.isArray(value) && value.length === 0) {
            count++;
          } else if (typeof value === 'object') {
            count += countNullAndEmptyArrays(value, excludedPropertyName); // Recursively check nested objects
          }
        }
      }

      return count;
    },
    async checkProcessobjectPermission(){
      let res = await this.$store.dispatch('hasPermission', 'EDIT_CONTEXTITEM');
      this.canEditProcessobjects = res;
    }
  },
  methods: {

    getCustomFieldValue(fieldId){
      let field = this.processCharacteristic.customFields.find(elem => elem.customFieldId == fieldId);
      if(field == null){
        this.processCharacteristic.customFields.push({
          customFieldId:fieldId,
          fieldValue: null
        })
      }
      return this.processCharacteristic.customFields.find(elem => elem.customFieldId == fieldId).fieldValue;
    },
    resetDefaultMap(){
      this.processCharacteristic = {
        name: null,
        trigger: null,
        outcome: null,
        description: null,
        department: null,
        systems: null,
        connectedDepartments: [],
        connectedModel: null,
        involvedRoles: null,
        connectedProcesses: [],
        customFields: []
      }
    },
    loadRessources(){
      connectedRessourceService.retrieveConnectedRessources().then((res) => {
        this.departments = res.data.filter(elem => elem.type == "DEPARTMENT");
        this.systems = res.data.filter(elem => elem.type == "SYSTEM");
        this.roles = res.data.filter(elem => elem.type == "ROLE");
        let fieldValues = {};
        processMapService.getCustomFields().then(response => {
          this.customFields = response.data;
          this.customFields.forEach(field => {
            fieldValues[field.fieldId] = {
              id: field.id,
              value: null
            }
            if(field.fieldType == "NUMBER"){
              this.minMaxRules.push(v => v < field.maxValue || "Wert zu groß. Maximum ist "+field.maxValue, v => v > field.minValue || "Wert zu klein. Minimum ist "+field.minValue);
            }
          })
          Object.assign(this.customFieldValues, fieldValues)
          this.dialog = true;
        })
      })
    },
    open(viewMode, characteristics) {
      this.loadRessources();
      
      this.viewMode = viewMode;
      if(viewMode) {
        this.processCharacteristic = characteristics
      }else{
        this.characteristics = characteristics;
      }
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    sendResponse(){
      for(const [key, data] of Object.entries(this.customFieldValues)){
        this.processCharacteristic.customFields.push(
          {
            customFieldId: data.id,
            fieldValue: data.value
          }
        )
      }
      this.resolve(this.processCharacteristic)
      //this.resetDefaultMap();
      //this.dialog = false;
    },
    close(){
      this.reject();
      this.resetDefaultMap();
      this.dialog = false;
    },
    openDialog(type){
      this.$refs.ressourceDialog
      .open(type, true, true)
      .then(() => this.loadRessources());
    },
    addField(){
      this.$refs.customFieldDialog
      .open()
      .then((res) => {
        let defaultVal = res.defaultValue;
        res.defaultValue = { type: (res.fieldType == 'NUMBER' ? 'NUMBER': 'OPTIONS'), value: defaultVal };
        res.defaultValue = JSON.stringify(res.defaultValue);
        processMapService.addCustomField(res).then(resp => {
          res.defaultValue = JSON.parse(res.defaultValue);
          res.id = resp;
          this.customFields.push(res);
        })
      });
    }
  }
};
</script>
<style scoped>
h3 {
  color: #575757;
}
.v-dialog{
  overflow-y: unset !important;
}
#cardFrame{
  border-radius: 10px;
  border: 1px solid #EFEFEF;
}
.svg-container {
  width: 5rem;
  height: 5rem;
}
#rowContainer{
  align-items:center
}
.v-expansion-panel-header{
  background-color: #f5f5f5;
}
</style>